import { useMemo, useState } from 'react'
import { useForm } from 'react-hook-form'
import useQuery from 'hooks/useQuery'
import { filterEmptyValues } from 'utils/helpers'
import { Button, Dropdown, TextInput } from 'components/common'
import { SapOperationType, SapLogStatus } from 'types/sap'

type Props = {
  toggleFilterForm: () => void
}

export const FILTER_FIELD_SAP_LOG = 'sapLogFilters'

const SapLogFilterForm = ({ toggleFilterForm }: Props) => {
  const { getQuery, removeQuery, setMultipleQueries } = useQuery()
  const filters = getQuery(FILTER_FIELD_SAP_LOG)

  const [resetFilter, setResetFilter] = useState(false)

  const { handleSubmit, setValue, reset, register } = useForm({
    defaultValues: filters,
  })

  const onFilterApply = (data: any) => {
    if (data?.type === 'NONE') {
      delete data.type
    }

    if (data?.status === 'NONE') {
      delete data.status
    }

    const filteredData = filterEmptyValues(data)
    if (Object.values(filteredData).length > 0) {
      setMultipleQueries({ [FILTER_FIELD_SAP_LOG]: filteredData, page: 1 })
    } else {
      removeQuery(FILTER_FIELD_SAP_LOG)
    }

    toggleFilterForm()
  }

  const cancelFilter = () => {
    reset(filters)
    setResetFilter((pre) => !pre)
    toggleFilterForm()
  }

  const typeOptions = useMemo(
    () => [
      { label: '--- NONE ---', value: 'NONE' },
      { label: 'Catalogues', value: SapOperationType.CATALOGUES },
      { label: 'Inventory', value: SapOperationType.INVENTORY },
      { label: 'Pricing', value: SapOperationType.PRICING },
    ],
    [],
  )

  const statusOptions = useMemo(
    () => [
      { label: '--- NONE ---', value: 'NONE' },
      { label: 'Processing', value: SapLogStatus.PROCESSING },
      { label: 'Success', value: SapLogStatus.SUCCESS },
      { label: 'Failed', value: SapLogStatus.FAILED },
    ],
    [],
  )

  return (
    <div className="mt-2 rounded-lg border bg-white px-5 py-3">
      <div className="mx-auto max-w-5xl">
        <form onSubmit={handleSubmit(onFilterApply)}>
          <div className="grid grid-cols-2 gap-x-14 gap-y-3 md:grid-cols-3">
            <TextInput
              name="requestId"
              label="Request Id"
              register={register}
            />

            {/* Type Filter */}
            <Dropdown
              name="type"
              label="Type"
              setValue={setValue}
              defaultValue={filters?.['type'] || resetFilter}
              options={typeOptions}
            />

            {/* Status Filter */}
            <Dropdown
              name="status"
              label="Status"
              setValue={setValue}
              defaultValue={filters?.['status'] || resetFilter}
              options={statusOptions}
            />
          </div>

          <div className="my-4 flex gap-5">
            <Button buttonText="Apply Filters" className="w-32" />
            <Button
              buttonText="Cancel"
              variant="outline"
              type="button"
              onClick={cancelFilter}
              className="w-32"
            />
          </div>
        </form>
      </div>
    </div>
  )
}

export default SapLogFilterForm
